import { useQuery } from "react-query";
import TrainingRequestsOverviewService from "./TrainingRequestsOverviewService";

const useTrainingRequestsOverview = () => {

  const { data: requests = [], isLoading: loadingRequests } = useQuery(
    "trainingRequests",
    async () => {
      const res = await TrainingRequestsOverviewService.getRequests();
      return res.data; 
    }
  );

  const { data: stats = {}, isLoading: loadingStats } = useQuery(
    "trainingRequestStats",
    async () => {
      const res = await TrainingRequestsOverviewService.getRequestStats();
      return res.data; 
    }
  );


  const { data: byDepartment = [], isLoading: loadingByDept } = useQuery(
    "trainingRequestsByDepartment",
    async () => {
      const res = await TrainingRequestsOverviewService.getRequestsByDepartment();
      return res.data; 
    }
  );


  const { data: trend = [], isLoading: loadingTrend } = useQuery(
    "trainingRequestsTrend",
    async () => {
      const res = await TrainingRequestsOverviewService.getRequestsTrendOverTime();
      return res.data; 
    }
  );

  return {
    requests,
    stats,
    byDepartment,
    trend,
    loadingRequests,
    loadingStats,
    loadingByDept,
    loadingTrend,
  };
};

export default useTrainingRequestsOverview;
